import { useQuery } from '@tanstack/react-query'
import { BoardRole } from '../types/board-roles'
import { ISocietiesModel } from '../interfaces/models/societies.interfaces'
import { userQueries } from '../api/users'

export const useUserRole = (
  society: ISocietiesModel | undefined,
  userId?: string
):
  | 'member'
  | 'president'
  | 'vicepresident'
  | 'treasury'
  | 'secretary'
  | 'alternate'
  | 'advisor'
  | 'nominating-committee'
  | BoardRole.NOMINATING_COMMITTEE
  | undefined => {
  const { data: user } = useQuery(userQueries.getUser(userId))
  const userBoardRole =
    user && society?.boardMembersList
      ? society?.boardMembersList.find((_member) => _member.userId === user._id)
          ?.role
      : undefined
  const userOnNominattingCommittee =
    user && society?.nominatingCommitteeList
      ? society?.nominatingCommitteeList.find(
          (_member) => _member.userId === user._id
        )
      : undefined

  const userRole =
    userBoardRole ||
    (userOnNominattingCommittee ? BoardRole.NOMINATING_COMMITTEE : undefined)

  return userRole
}
